"use client";
import CartModal from "@/components/ui/ecommerce/cart/CartModal";
import { CartIcon } from "@/components/ui/Icons";
import { useCartStore2 } from "@/stores/cartStore";
import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";

export default function CartBtnFixed() {
  const { cart2, fetchCart } = useCartStore2();
  const [openCart, setOpenCart] = useState(false);
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!cart2) {
      fetchCart();
    }
    setMounted(true);
  }, [fetchCart, cart2]);

  const handleOpenCart = () => {
    setOpenCart(true);
  };

  const handleCloseCart = () => {
    setOpenCart(false);
  };

  if (!mounted) return null;
  if (pathname === "/payment") return null;
  if (!cart2 || !cart2.items || cart2.items.length === 0) return null;

  // Calcular el número total de items
  const itemCount = cart2.items.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <>
      <div className="fixed bottom-6 right-6 z-50">
        <button
          className="relative bg-bright-pink text-white p-3 rounded-md"
          onClick={handleOpenCart}
        >
          <CartIcon className="fill-cream w-7 h-7" />
          <span className="absolute -top-2 -right-2 bg-orange text-xs font-semibold rounded-full px-2">
            {itemCount}
          </span>
        </button>
      </div>
      <CartModal open={openCart} onClose={handleCloseCart} />
    </>
  );
}
